export default "__VITE_ASSET__Ctq36huS__"